export default __webpack_public_path__ + "static/media/send_on.4df8ca42.png";